var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-8" },
        [
          _c(
            "b-form-group",
            { attrs: { label: "Select GSTR1 Zip File(s)" } },
            [
              _c("b-form-file", {
                attrs: { multiple: "", accept: "application/zip" },
                model: {
                  value: _vm.file,
                  callback: function($$v) {
                    _vm.file = $$v
                  },
                  expression: "file"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-auto align-right" }, [
        _c("div", { staticClass: "mt-2" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary mt-4",
              attrs: { type: "button", disabled: _vm.status === "STARTED" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.reconcile()
                }
              }
            },
            [
              _vm.status !== "IDLE" && _vm.status !== "COMPLETED"
                ? _c("span", [_vm._v("Checking ... ")])
                : _vm._e(),
              _vm._v(" "),
              _vm.status === "IDLE" || _vm.status === "COMPLETED"
                ? _c("span", [_vm._v("Check")])
                : _vm._e()
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _vm.status === "COMPLETED"
          ? _c("div", { staticClass: "row pb-3" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "col-auto" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.stateName,
                        expression: "stateName"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.stateName = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.filterReport
                      ]
                    }
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [
                      _vm._v("All States")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.stateNames, function(st) {
                      return _c(
                        "option",
                        { key: st, domProps: { value: st } },
                        [_vm._v(_vm._s(st))]
                      )
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-auto mt-2" }, [
                _c("div", { staticClass: "custom-control custom-switch" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.ignoreURP,
                        expression: "ignoreURP"
                      }
                    ],
                    staticClass: "custom-control-input",
                    attrs: { type: "checkbox", id: "customSwitch1" },
                    domProps: {
                      checked: Array.isArray(_vm.ignoreURP)
                        ? _vm._i(_vm.ignoreURP, null) > -1
                        : _vm.ignoreURP
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = _vm.ignoreURP,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.ignoreURP = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.ignoreURP = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.ignoreURP = $$c
                          }
                        },
                        _vm.filterReport
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "custom-control-label",
                      attrs: { for: "customSwitch1" }
                    },
                    [_vm._v("Ignore URP EWaybills")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-auto mt-2" }, [
                _c("div", { staticClass: "custom-control custom-switch" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.only50K,
                        expression: "only50K"
                      }
                    ],
                    staticClass: "custom-control-input",
                    attrs: { type: "checkbox", id: "customSwitch2" },
                    domProps: {
                      checked: Array.isArray(_vm.only50K)
                        ? _vm._i(_vm.only50K, null) > -1
                        : _vm.only50K
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = _vm.only50K,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.only50K = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.only50K = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.only50K = $$c
                          }
                        },
                        _vm.filterReport
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "custom-control-label",
                      attrs: { for: "customSwitch2" }
                    },
                    [_vm._v("Only Value > 50K")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-auto" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.filterDoc,
                        expression: "filterDoc"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.filterDoc = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.filterReport
                      ]
                    }
                  },
                  [
                    _c("option", { attrs: { value: "ALL" } }, [
                      _vm._v("All Doc Types")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "INVOICE" } }, [
                      _vm._v("Only Invoices")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "CREDIT_NOTE" } }, [
                      _vm._v("Only Credit Notes")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "DEBIT_NOTE" } }, [
                      _vm._v("Only Debit Notes")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "EXPORT" } }, [
                      _vm._v("Only Export Invoices")
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-auto" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.filter,
                        expression: "filter"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.filter = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.filterReport
                      ]
                    }
                  },
                  [
                    _c("option", { attrs: { value: "NONE" } }, [
                      _vm._v("Show All")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "MATCH" } }, [
                      _vm._v("Show Only Correct Data")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "DATA_MISMATCH" } }, [
                      _vm._v("Show Only Data Mismatch")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "INVOICE_MISSING" } }, [
                      _vm._v("Show Only Unknown EWB Entries")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "EWB_MISSING" } }, [
                      _vm._v("Show Only Invoices with no EWB")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "NO_PARTB" } }, [
                      _vm._v("Show Only EWB with No-PartB")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "ONLY_PARTB" } }, [
                      _vm._v("Show Only EWB with PartB")
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-auto" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-info",
                    on: {
                      click: function($event) {
                        return _vm.downloadExcel()
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-download" }), _vm._v(" Excel")]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.status === "COMPLETED"
          ? _c("table", { staticClass: "table table-sm" }, [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.reconciled, function(e, index) {
                  return _c("tr", { key: e.docNo }, [
                    _c("td", [_vm._v(_vm._s(index + 1))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(e.docType))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(e.state))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(e.consigneeGst))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(e.invoiceNo))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(e.invoiceDt))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(e.invoiceVal))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(e.ewbNo))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(e.ewbConsigneeGst))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(e.ewbInvoiceNo))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(e.ewbInvoiceDt))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(e.ewbInvoiceVal))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(e.ewbExpiryStr))])
                  ])
                }),
                0
              )
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col" }, [
        _c("h4", { staticClass: "form-head" }, [_vm._v("Reconciliation")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-auto" }, [
      _c("h4", [_vm._v("Results")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "thead-dark" }, [
      _c("tr", [
        _c("th", [_vm._v(" ")]),
        _vm._v(" "),
        _c("th", [_vm._v("Doc Type")]),
        _vm._v(" "),
        _c("th", [_vm._v("State")]),
        _vm._v(" "),
        _c("th", [_vm._v("Invoice Consignee GST")]),
        _vm._v(" "),
        _c("th", [_vm._v("Invoice No")]),
        _vm._v(" "),
        _c("th", [_vm._v("Invoice Dt")]),
        _vm._v(" "),
        _c("th", [_vm._v("Invoice Value")]),
        _vm._v(" "),
        _c("th", [_vm._v("E-Waybill No")]),
        _vm._v(" "),
        _c("th", [_vm._v("E-Waybill Consignee GST")]),
        _vm._v(" "),
        _c("th", [_vm._v("E-Waybill Invoice No")]),
        _vm._v(" "),
        _c("th", [_vm._v("E-Waybill Invoice Dt")]),
        _vm._v(" "),
        _c("th", [_vm._v("E-Waybill Invoice Value")]),
        _vm._v(" "),
        _c("th", [_vm._v("E-Waybill Validity")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53dfd706", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53dfd706","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EWaybillReconcile.vue
// module id = null
// module chunks = 